export default __webpack_public_path__ + "static/media/bindingactuator.109b328a.PNG";